// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__K3yYS","label":"LabeledBox_label__3b4Wv"};